import PropTypes from 'prop-types'
import { Button, Popconfirm } from 'antd'
import { CalendarOutlined, DeleteOutlined } from '@ant-design/icons'
import { createUseStyles } from 'react-jss'
import dayjs, { formatDOB } from '../../lib/datetime'
import PatientEntry from '../Common/PatientEntry'

const useStyles = createUseStyles({
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  name: {
    fontWeight: 600,
    fontSize: 15,
    minWidth: 0,
    overflowWrap: 'anywhere',
    // PatientEntry sets the link to nowrap for the desktop table; on mobile we
    // let a long name wrap instead of overflowing.
    '& a': {
      whiteSpace: 'normal !important',
    },
  },
  line: {
    fontSize: 13,
    color: '#595959',
    overflowWrap: 'anywhere',
  },
  lineIcon: {
    marginRight: 6,
    color: '#8c8c8c',
  },
})

// Every desktop column fits on the card, so these rows need no expand toggle.
export default function PendingReportMobileCard({ report, onReject }) {
  const classes = useStyles()
  const { createdAt, id, patientSummary, practice } = report
  // formatDOB(undefined) would render today's date, so only format a real value.
  const dob = patientSummary?.birthDate
    ? formatDOB(patientSummary.birthDate)
    : null
  const detailLine = [dob, practice?.name].filter(Boolean).join(' · ')
  const patientName = patientSummary
    ? `${patientSummary.lastName}, ${patientSummary.firstName}`
    : '—'

  return (
    <div className={classes.card}>
      <div className={classes.name}>
        {patientSummary?.id ? (
          <PatientEntry patient={patientSummary} />
        ) : (
          patientName
        )}
      </div>
      {detailLine && <div className={classes.line}>{detailLine}</div>}
      {createdAt && (
        <div className={classes.line}>
          <CalendarOutlined className={classes.lineIcon} />
          {dayjs(createdAt).calendar(null, { sameElse: 'lll' })}
        </div>
      )}
      <div>
        <Popconfirm
          title="Are you sure you want to reject this report?"
          onConfirm={() => onReject(id)}
          okText="Yes"
          cancelText="No"
          placement="topLeft"
        >
          <Button
            type="link"
            size="small"
            icon={<DeleteOutlined />}
            className="delete-button"
            style={{ paddingLeft: 0 }}
          >
            Reject
          </Button>
        </Popconfirm>
      </div>
    </div>
  )
}

PendingReportMobileCard.propTypes = {
  onReject: PropTypes.func.isRequired,
  report: PropTypes.shape({
    id: PropTypes.string.isRequired,
    createdAt: PropTypes.string,
    patientSummary: PropTypes.shape({
      id: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      birthDate: PropTypes.string,
    }),
    practice: PropTypes.shape({
      name: PropTypes.string,
    }),
  }).isRequired,
}
